module.exports = __webpack_public_path__ + "img/cancelMeetings.68a426e9.svg";